import React from "react";
import { array, string, object, bool } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import { staticTexts } from "../../utils/Translate";

import "./numberedStoryHeadline.m.css";

const NumberedStoryHeadline = ({ storyList, className = "", publisherAttributes, updatedFont = false }) => {
  const headlineStyle = updatedFont ? `${publisherAttributes.lang}-story-headline` : "";

  return (
    <div className="numbered-story-headline-wrapper">
      {storyList.map(({ story }, index) => (
        <Link href={story.url} key={index} styleName="wrapper" className={className}>
          <div styleName="content" className="content numbered-story-headline">
            <span
              styleName={`headline-number ${publisherAttributes.lang === "en" ? "en-headline-number" : ""}`}
              className={`headline-number ${publisherAttributes.lang === "en" ? "en-headline-number" : ""}`}
            >
              {staticTexts(publisherAttributes.lang).NUMBER_ARRAY[index + 1]}
            </span>
            <Headline
              text={story.headline}
              headlineType={16}
              headerLevel={3}
              className="story-headline"
              styleName={headlineStyle}
            />
          </div>
        </Link>
      ))}
    </div>
  );
};

NumberedStoryHeadline.propTypes = {
  className: string,
  storyList: array,
  publisherAttributes: object,
  updatedFont: bool
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(NumberedStoryHeadline);
